<template>
  <div class="square">
    <div class="container">
      <div class="header">
        <div class="img"></div>
        <div class="btn" @click="join">立即下载</div>
      </div>
      <div class="content">
        <div class="infos">
          <div class="avator">
            <img :src="avatar" alt>
          </div>
          <div class="info">
            <span class="name">{{nickname}}</span>
            <span class="sex">
              <img :src="role_avatar" alt>
            </span>
            <p class="time">{{time}}</p>
          </div>
        </div>
        <div class="item" v-if="baseType===2">
          <p class="message">{{message}}</p>
          <div class="image">
            <ul >
              <li class="longPic" v-for="(item,index) in picInfoList" :key="index" >
                <img :src="item.picUrl" alt>
              </li>
            </ul>
            
          </div>
        </div>
        <div class="item" v-else-if="baseType===1">
          <p class="message">{{squareBaseText}}</p>
        </div>
      </div>
      <div class="footer" @click="join">
        <div class="ft_infos">
          <span class="image">
            <img src="../assets/images/square/community_present_icon@2x.png" alt>
          </span>
          <span :class="{info:true,pink:true}">送礼</span>
          <span class="image">
            <img src="../assets/images/square/community_dianzan_icon@2x.png" alt>
          </span>
          <span class="info">{{likeCount}}</span>
          <span class="image">
            <img src="../assets/images/square/community_pinglun_icon@2x.png" alt>
          </span>
          <span class="info">{{commentCount}}</span>
          <span class="image">
            <img src="../assets/images/square/community_fenxiang_icon@2x.png" alt>
          </span>
          <span class="info"></span>
        </div>
      </div>
          <Appopen
          :title="'我是谜app打开方式'"
          :browser="'1.'+ '点击右上角[...]'"
          :direct="'2. '+'选择[在浏览器中打开]'"
          :isAppopen="isAppopen"
        ></Appopen>
    </div>
  </div>
</template>
<script>
import { FormatTime, formatNumber, formatTime } from "../assets/js/time.js";
import {appUrlAndroid,appUrlIOS} from "../assets/js/base64"
import Man from "../assets/images/square/role_man_icon@2x.png";
import Woman from "../assets/images/square/role_wman_icon@2x.png";
import axios from "axios";
export default {
  data() {
    return {
      avatar: "",
      nickname: "",
      time: "",
      baseType: "",
      message: "",
      picInfoList: [],
      role_avatar: "",
      hieght: "",
      likeCount: "",
      commentCount: "",
      squareBaseText: "",
      isAppopen:false
    };
  },
  components:{
     Appopen: () => import("../component/Appopen.vue")
  },
  created() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const squareBaseId = this.$route.query.squarebaseid;
    document.getElementsByTagName("title")[0].innerText = "我是谜";
    axios
      .post(this.$interfaces.getWebSquareBaseDetail, {
        squareBaseId: squareBaseId  
      })
      .then(res => {
        if (res.data.code == 200) {
          this.squareBaseDetail = res.data.data.squareBaseDetail;
          this.avatar = this.squareBaseDetail.avatar;
          this.nickname = this.squareBaseDetail.nickname;
          this.time = FormatTime(this.squareBaseDetail.createTime);
          this.baseType = this.squareBaseDetail.baseType; 
          this.role_avatar = this.squareBaseDetail.sex == 1 ? Man : Woman;

          this.commentCount = this.squareBaseDetail.commentCount; 
          this.likeCount = this.squareBaseDetail.likeCount; 
          if (this.baseType == 2) {
            this.picInfoList = this.squareBaseDetail.squareBasePic.picInfoList; 
            this.message = this.squareBaseDetail.squareBasePic.message; 
          } else if (this.baseType == 1) {
            this.squareBaseText = this.squareBaseDetail.squareBaseText.message; 
          } else {
            return;
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    join(){
      this.baseUrl='https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan'
       if (this.isAndroid) {
          window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid( "100000")}`;
        } else if (this.isiOS) {
           let ua = navigator.userAgent.toLowerCase();
           if(ua.match(/QQ/i) == "qq"){
             this.isAppopen = true
           }else{
              window.location.href = appUrlIOS('100000');
           }
        }else{
             window.location.href = 'http://share.xiyacs.com/#/open'
        }
    }
  }
};
</script>
<style scoped>
.square {
  width: 100%;
  height: 100%;
}
li {
  list-style: none;
}
.square .container{
  position: relative;
}
.square .container .header {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  padding-top: 0.45rem;
  width: 100%;
  /* border:0.025rem solid red; */
  height: 3rem;
  background: linear-gradient(
    90deg,
    rgba(48, 207, 238, 1) 0%,
    rgba(83, 255, 246, 1) 100%
  );
}
.square .container .header .img {
  background: url("../assets/images/square/img@2x.png") 0 0 no-repeat;
  background-size: 100% 100%;
  height: 2.1rem;
  width: 4.9rem;
  line-height: 2.1rem;
  float: left;
}
.square .container .header .btn {
  float: right;
  width: 6rem;
  height: 2.1rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 1.05rem;
  line-height: 2.1rem;
  font-size: 0.8rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(56, 218, 240, 1);
}
.square .container .content {
  padding-top: 3rem;
  padding-bottom: 3.6rem;
  margin-top: 0.9rem;
}
.square .container .content .infos {
  display: flex;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}
.square .container .content .item .message {
  margin-top: 0.75rem;
  font-size: 0.75rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(87, 86, 90, 1);
  line-height: 1.05rem;
  text-align: left;
  margin-bottom: 0.75rem;
  /* 保留空格 和自动换行样式 */
  white-space: pre-line;
  /* 数字英文字母自动换行 */
  word-wrap: break-word;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}
.square .container .content .item .image .longPic {
  width: 100%;
  height: 100%;
}
.square .container .content .item .image .longPic img {
  width: 100%;
  height: 100%;
}
.square .container .content .item .image .lis img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.square .container .content .infos .avator {
  flex: 0 0 2.1rem;
  width: 2.1rem;
  height: 2.1rem;
  /* border:0.025rem solid pink; */
  overflow: hidden;
  border-radius: 50%;
}
.square .container .content .infos .avator img {
  width: 100%;
  height: 100%;
}
.square .container .content .infos .info {
  flex: 1;
  padding-left: 0.3rem;
  text-align: left;
}
.square .container .content .infos .info .name {
  font-size: 0.75rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(87, 86, 90, 1);
  line-height: 1.05rem;
}
.square .container .content .infos .info .sex {
  display: inline-block;
  width: 0.6rem;
  height: 0.6rem;
}
.square .container .content .infos .info .sex img {
  width: 100%;
  height: 100%;
}
.square .container .content .infos .info .time {
  font-size: 0.6rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(185, 192, 207, 1);
  line-height: 0.85rem;
}
/* 底部 */
.square .container .footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2.7rem;
  padding-left: 0.6rem;
  border-top: 0.025rem solid #ccc;
  background: white;
  z-index: 999;
}
.square .container .footer .ft_infos {
  text-align: left;
  height: 1.2rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.square .container .footer .ft_infos .image {
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.125rem;
  vertical-align: middle;
  /* 行内块元素垂直居中 */
}
.square .container .footer .ft_infos .image img {
  width: 100%;
  height: 100%;
}
.square .container .footer .ft_infos .info {
  display: inline-block;
  width: 2.75rem;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.75rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(185, 192, 207, 1);
  /* overflow: hidden; */
}
.pink {
  color: rgba(253, 149, 176, 1) !important;
}
.motail {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background: rgba(87, 86, 90, 0.5);
}
.motail .motail_in {
  position: absolute;
  top: 20%;
  width: 27rem;
  height: 17rem;
}
.motail .motail_in img {
  width: 100%;
  height: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/Squareshare.vue